import { Category } from '~app/modules/generic/models';

export namespace CategoriesUtil {
  // transforms object lists to arrays
  export function getCategoryArray(categories: Object): Category[] {
    return Object.values(categories).map((category: Category) =>
      category.children
        ? {
          ...category,
          children: getChildrenCategories(category),
        }
        : category
    );
  }

  function getChildrenCategories(parentCategory: Category): Category[] {
    return Object.values(parentCategory.children).map((category: Category) =>
      category.children
        ? {
          ...category,
          children: getChildrenCategories(category),
          parents: [parentCategory],
        }
        : category
    );
  }
}
